import { Api } from "./Api";
require('dotenv');
const axios = require('axios').default;


let TimesheetApi = {

    endpoint: "Timesheets/",

    async add(item) {
        delete item.id;


        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.post(URL, item, { withCredentials: true });
        return response;
    },

    async update(item) {

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + item.id;

        const response = await axios.put(URL, item, { withCredentials: true });
        return response;
    }
    ,
    async delete(id) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + id;
        const response = await axios.delete(URL, { withCredentials: true });
        return response;
    },
    async inactivate(id, reason) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + id + "/inactivate";
        const response = await axios.post(
            URL,
            { reason },
            { withCredentials: true }
        );
        return response;
    }
}

//Add the Api Mixin
TimesheetApi = Object.assign({}, Api, TimesheetApi);

export { TimesheetApi };
